import React from 'react';
import './HeroSkeleton.css';

export default function HeroSkeleton() {
  return (
    <div className="hero-skeleton" role="status">
      <div className="hero-skeleton-content" aria-hidden="true">
        <div className="hero-skeleton-accent" />
        <div className="hero-skeleton-line hero-skeleton-heading" />
        <div className="hero-skeleton-line hero-skeleton-heading hero-skeleton-heading-short" />
        <div className="hero-skeleton-line hero-skeleton-subtitle" />
        <div className="hero-skeleton-line hero-skeleton-subtitle hero-skeleton-subtitle-short" />
      </div>
      <span className="hero-skeleton-label">Ачаалж байна...</span>
    </div>
  );
}
